import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { colors } from 'styles/colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      // overflowY: 'auto',
      width: '34%',
      margin: '0 10px',
      borderRight: '1px solid #a1a1a1',
      height: '100%',
      padding: '0 8px 0 0',

      '& .css-1xjgcmr-MuiButtonBase-root-MuiToggleButton-root.Mui-selected': {
        background: 'rgb(88, 147, 222)',
        color: '#fff',
      },
      '& .MuiDataGrid-cellContent': {
        fontSize: '13px',
      },
      '& .MuiFormControl-fullWidth': {
        width: '81%',
      },
    },
    mainHeader: {
      display: 'flex',
      marginBottom: '15px',
      marginTop: '15px',
    },
    gridHeader: {
      display: 'flex',
      marginTop: '15px',
    },
    h3: {
      fontSize: '0.8rem',
    },
    h2: {
      color: 'rgb(88, 147, 241)',
      display: 'inline-block',
      fontSize: '1.25rem',
      marginBottom: '8px',
      marginRight: '12px',
      marginTop: '13px',
    },
    inputLabel: {
      color: 'rgb(88, 147, 241)',
      display: 'block',
      fontSize: '1rem',
      marginBottom: '5px',
      width: '200px',
    },

    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      maxWidth: 300,
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 2,
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
    formBaseInput: {
      '& .MuiFormHelperText-root': {
        color: colors.gray,
      },
    },
    button: {
      width: '20px',
      padding: '6px 3px',
      whidth: '20px',
    },
    singleButton: {
      margin: '8px 2px',
      padding: '5px',
      whidth: '23px',
      minWidth: '39px !important',
      minHeight: '40px !important',
      borderRadius: '0 5px !important',
      borderColor: 'darkgrey !important',
      color: 'black !important',
    },
    rightButton: {
      margin: '0px 20px !important',
      padding: '5px',
      minWidth: '50px !important',
      minHeight: '40px !important',
      borderRadius: '5px !important',
      borderColor: '#397ffe  !important',
      color: '#397ffe !important',
    },

    leftButton: {
      margin: '0px -5px !important',
      padding: '5px',
      whidth: '23px',
      minWidth: '44px !important',
      minHeight: '40px !important',
      borderRadius: '0 5px 5px 0 !important',
      borderColor: 'darkgrey !important',
      color: '#595959 !important',
      backgroundColor: '#fff !important',
      zIndex: 33,
    },
    cmbAtividade: {
      borderRadius: '5px 0 0 5px !important',
    },
  }),
);

// const useStyles = makeStyles({

// });

export default useStyles;
